export const mobileCarouselSchemaEnhancer = ({ schema, formData, intl }) => {
  const { fieldsets, properties } = schema;

  return {
    ...schema,
    fieldsets: [
      ...fieldsets,
      {
        id: 'mobile_carousel',
        title: 'Show carousel on mobile view',
        fields: ['mobile_carousel'],
      },
    ],
    required: [],
    properties: {
      ...properties,
      mobile_carousel: {
        title: 'Show carousel on mobile view',
        type: 'boolean',
      },
    },
  };
};
